import { Column, Text } from '~/commonComponents';
import { IPendingReview } from '~/domain/ShiftReview';
import { getShouldEnforcePermanentJobV2 } from '~/growthbook';
import { Colors } from '~/themes/colors';

interface IProps {
  it: IPendingReview;
}

export const AdjustmentDetailV1 = ({ it }: IProps) => {
  return (
    <Column>
      {getShouldEnforcePermanentJobV2() && (
        <Column
          alignSelf="flex-start"
          paddingBlock={2}
          paddingInline={10}
          marginBottom={5}
          borderRadius={8}
          backgroundColor={
            it?.isOnsiteInterview ? Colors.jobs_interview_background : Colors.jobs_shift_background
          }
        >
          <Text color="neutral_500">{it?.isOnsiteInterview ? 'INTERVIEW' : 'SHIFT'}</Text>
        </Column>
      )}
      <Text bold>{it.shift.localDate}</Text>
      <Column>
        <Text
          color={Colors.neutral_500}
          textDecorationLine={it.hasAdjustShiftTime ? 'line-through' : 'none'}
        >
          {it.shift.localStartTime} - {it.shift.localEndTime}
        </Text>
        {it.hasAdjustShiftTime && (
          <Text color={Colors.neutral_500}>
            {it.adjustment?.localStartTime} - {it.adjustment?.localEndTime}
          </Text>
        )}
      </Column>
      <Column>
        <Text
          color={Colors.neutral_500}
          textDecorationLine={it.hasAdjustBreakTime ? 'line-through' : 'none'}
        >
          Meal Break: {it.shift.breakTime}
        </Text>
        {it.hasAdjustBreakTime && (
          <Text color={Colors.neutral_500}>Meal Break: {it.adjustment?.breakTime}</Text>
        )}
      </Column>
    </Column>
  );
};
